import { render, staticRenderFns } from "./CodeManage.vue?vue&type=template&id=64d6c04d&scoped=true"
import script from "./CodeManage.vue?vue&type=script&lang=js"
export * from "./CodeManage.vue?vue&type=script&lang=js"
import style0 from "./CodeManage.vue?vue&type=style&index=0&id=64d6c04d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6c04d",
  null
  
)

export default component.exports